import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useAllPositionList,
  useEmployeeListData,
  useGetEmployeeStatusData,
  useGetGradeMastersData,
  useGetOrgUnitsData,
} from "./hooks/useEmployee";
import { FaEye } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import EditProfileModal from "./components/EditProfileModal";
import { getAllPositionList } from "./hooks/EmployeeRepository";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { useDispatch, useSelector } from "react-redux";
import { resetDropDown, setEmployeeStatus, setGrade, setOrgUnit, setPosition } from "../../ReduxToolkit/Reducers/Employee/EmployeeListModule";
import { useHardRefresh } from "../../Component/BasicComponents/Hooks/useHardRefresh";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";


type Props = {};
// const HeaderContent = (props: any) => {
//   const handleFilter = (key: any, selected: any) => {
//     props?.setFiltersState((prev: any) => ({
//       ...prev,
//       [key]: selected.id === "null" ? null : Number(selected.id),
//     }));
//   };

//   return (
//     <div
//       style={{
//         marginBottom: "15px",
//         gap: "10px",
//         display: "flex",
//         justifyContent: "flex-end",
//       }}
//     >
//       <RoundedDropdown
//         options={props?.orgUnitsList || []}
//         onSelect={(e) => {
//           handleFilter("orgUnits", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Org Unit"
//         headingColor="#2e8dd3"
//       />
//       <RoundedDropdown
//         options={props?.gradeMaster || []}
//         onSelect={(e) => {
//           handleFilter("gradeMaster", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Grade"
//         headingColor="#2e8dd3"
//       />

//                 <CustomDropdown
//                 placeholder="All"
//                 DropdownLabel="Position"
//                 value={props.filterstate?.Position}
//                 onChange={(id) => {
//                   props.setFiltersState((prev: any) => ({
//                     ...prev,
//                     Position: id,
//                     page: 1,
//                   }));
//                 }}
//                 fetchData={async ({ page, limit, search }) => {
//                   const res = await getAllPositionList({
//                     page,
//                     limit,
//                     search,
//                   });

//                   const rawData = res?.data?.Positions || {};
//                   console.log(rawData)
//                   let formatted = rawData?.map(
//                     (item:any) => ({
//                       id:item.PositionId,
//                       label: item.PositionName,
//                     })
//                   );

//                   // ✅ Add "All" only on the first page
//                   if (page === 1) {
//                     formatted = [{ id: "", label: "All" }, ...formatted];
//                   }
//                   const hasMore = Object.keys(rawData).length === limit;

//                   return {
//                     data: formatted,
//                     hasMore,
//                   };
//                 }}
//                 includeAllOption
//               />
//       {/* <RoundedDropdown
//         options={props?.PositionDropdownList|| []}
//         onSelect={(e) => {
//           handleFilter("Position", e);
//         }}
//         onSearch={(val) => props.onPositionSearch(val)}
//         defaultLabel="All"
//         width="auto"
//     onLoadMore={props.onPositionLoadMore}

//         isShowHeading
//         DropdownHeading="Position"
//         headingColor="#2e8dd3"
//       /> */}
//       <RoundedDropdown
//         options={props?.employeeStatus || []}
//         onSelect={(e) => {
//           handleFilter("status", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Status"
//         headingColor="#2e8dd3"
//       />
//     </div>
//   );
// };

const Employee = (props: Props) => {
  const [positionSearchTerm, setPositionSearchTerm] = useState("");
  const [positionPage, setPositionPage] = useState(1);
  const [positionHasMore, setPositionHasMore] = useState(true);
  const [positionOptions, setPositionOptions] = useState<any[]>([]);
  const [isModalOpen,setIsModalOpen]=useState(false)
  const [refresh,setRefresh]=useState(false)
  const [isDownloading,setIsDownloading]=useState(false)
    const [Disabled,setDisabled] = useState<boolean>(false);
      const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
      const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
  // const [position,setPosition]=useState<any>('')
  const dispatch = useDispatch() 
    const { filter,dropDown } = useSelector((state: any) => state.employeeModule); // 👈 now Redux filter

  console.log('selecteor',dropDown)
    useHardRefresh(()=> dispatch(resetDropDown()))
        const { startPolling, stopPolling } = useExcelPolling();
  
  const navigate = useNavigate();
  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const { data: gradeMaster } = useGetGradeMastersData({ enable: true });
  // const { data: designationsData } = useGetDesignationsData({ enable: true });
  const { data: employeeStatus } = useGetEmployeeStatusData({ enable: true });


  const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    gradeMaster: null,
    designation: null,
    status: null,
    limit: 10,
    page: 1,
    search: null,
    Position:null,
  });
  
  const { data,isLoading:isLoading } = useEmployeeListData({
    enable: true,
    params: {
      orgUnit:dropDown.orgUnit.id === null ? '' : dropDown?.orgUnit?.id,
      grade: dropDown.grade.id===null?'':dropDown?.grade?.id,
      status: dropDown.employeeStatus.id===null?'':dropDown.employeeStatus.id,
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
      position:dropDown.position.id===null?'':dropDown.position.id
    },
  });
    useEffect(() => {
    if (positionSearchTerm) {
      setPositionOptions([]);
      setPositionPage(1);
      setPositionHasMore(true);
    }
  }, [positionSearchTerm]);

  useEffect(() => {
  setPosition({ Position: "" }); // reset position
}, [dropDown.orgUnit]);

  // useEffect(() => {
  //   const newItems = Object.entries(PositionList?.data?.Positions || {}).map(([key, label]: any) => ({
  //     id: label.PositionId,
  //     label:label.PositionName,
  //   }));
  
  //   setPositionOptions((prev) => {
  //     // Combine previous and new, then deduplicate by `id`
  //     const combined = [...prev, ...newItems];
  
  //     // Create a map to remove duplicates (by id)
  //     const dedupedMap = new Map<string, { id: string; label: string }>();
  //     combined.forEach((item) => {
  //       dedupedMap.set(item.id, item);
  //     });
  
  //     // Convert back to array
  //     let deduped = Array.from(dedupedMap.values());
  
  //     // Ensure "All" is always the first option
  //     deduped = deduped.filter((item) => item.id !== "null");
  //     return [{ id: "null", label: "All" }, ...deduped];
  //   });
  
  //   if (newItems.length < 10) {
  //     setPositionHasMore(false);
  //   }
  // }, [PositionList]);

  const EmployeeListColumns = (handleEmployeeView: (row: any) => void) => [
    {
      name: "Emp Code",
      selector: (row: { EmployeeCode: number | string }) =>
        row.EmployeeCode || "-",
      sortable: true,
      minWidth:'130px',
      wrap:true
    
      
    },
   {
  name: "Emp Name",
  selector: (row: { FirstName: string; LastName: string }) => row.FirstName, // used for sorting
  cell: (row: { FirstName: string; LastName: string }) => (
    <Link
      to={`/employeeDetails`}
      state={{ employeeData: row }}
      style={{ textDecoration: "none", color: "blue" }}
    >
      {row.FirstName + " " + row.LastName || "-"}
    </Link>
  ),
  sortable: true,
  minWidth: "150px",
  wrap: true,
},
    {
      name: "HQ",
      selector: (row: { Stownname: string }) => row?.Stownname || "-", // (depend by backend)
      sortable: true,
      minWidth:'130px',
      wrap:true

    },
    {
      name: "Org Unit",
      selector: (row: { UnitName: string }) => row?.UnitName || "-", // (depend by backend)
      sortable: true,
      minWidth:'130px',
      wrap:true
    },
    {
      name: "Grade",
      selector: (row: { GradeName: string }) => row?.GradeName || "-",
      sortable: true,
         minWidth:'130px',
      wrap:true
    },
    {
      name: "Position",
      selector: (row: { PositionName: string }) => row?.PositionName || "-",
      sortable: true,
         minWidth:'130px',
      wrap:true
    },
    {
      name: "Phone No.",
      selector: (row: { Phone: string }) => row.Phone || "-", // need to add (depend by backend)
      sortable: true,
         minWidth:'130px',
      wrap:true
    },
   {
  name: "Status",
  cell: (row: { Status: string }) => {
    const status = employeeStatus?.response?.[row.Status] ?? "-";
    const isActive = status?.toLowerCase() === "active";

    return (
      <span
        style={{
          backgroundColor: isActive ? "#10c469" : "red",
          color: "white",
          padding: "4px 8px",
          borderRadius: "10px",
          fontWeight: "bold",
        }}
      >
        {status}
      </span>
    );
  },
  sortable: true,
  minWidth:'130px'
}
,
    {
      name: "Actions",
      minWidth:'150px',
      cell: (row: any) => (
        <button
          onClick={() => handleEmployeeView(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEye style={{ fill: "#fff" }} /> View
        </button>
      ),
    },
  ];

  // console.log('employeeStatus',employeeStatus?.['response'])

  const handleEmployeeView = (row: any) => {
    navigate("/employeeDetails", { state: { employeeData: row } });
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  const handleOrgUnit=(e:any)=>{
    // console.log('selectorOrgunit',e)
    dispatch(setOrgUnit(e))
  }

    const handleEmployeeStatus=(e:any)=>{
    // console.log('selectorOrgunit',e)
    dispatch(setEmployeeStatus(e))
  }

  const handlePosition=(e:any)=>{
    dispatch(setPosition(e))
  }

     const handleGrade=(e:any)=>{
    // console.log('selectorOrgunit',e)
    dispatch(setGrade(e))
  }

    const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };


  const handleAddEmployee=()=>{
setIsModalOpen(true)
  }

// const handleExcel = async () => {
//   try {
//     setIsDownloading(true);
//     const appToken = localStorage.getItem("Apptoken") || "";
//     const orgUnitId = dropDown?.orgUnit?.id || "";
//     const start = filtersState?.page || "";
//     const length = filtersState?.limit || "";
//     const search = filtersState?.search || "";
//     const position =dropDown.position.id||"";
//     const grade=dropDown.grade.id||"";

//     const params = new URLSearchParams();

//     // Append only if the value exists
//     if (orgUnitId) params.append("orgUnit", orgUnitId);
//     if (position) params.append("position", position);
//     if (grade) params.append("grade", grade);
//     if (start) params.append("page", start);
//     if (length) params.append("limit", length);
//     if (search) params.append("search", search);

//     const response = await fetch(
//       `https://tspc-development.truesales.in/admin/api/getEmployeeListExcel?params=travelled&${params.toString()}`,
//       {
//         method: "GET",
//         headers: {
//           accept: "application/json",
//           apptoken: appToken,
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to download Excel file");
//     }

//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "EmployeeList.xlsx"; // custom filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error downloading Excel file:", error);
//   }
//   finally{
//      setIsDownloading(false);
//   }
// };

  
  //   const handleFilter = (key: any, selected: any) => {
  //   setFiltersState((prev: any) => ({
  //     ...prev,
  //     [key]: selected.id === "null" ? null : Number(selected.id),
  //   }));
  // };


      const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
     const orgUnitId = dropDown?.orgUnit?.id || "";
    const start = filtersState?.page || "";
    const length = filtersState?.limit || "";
    const search = filtersState?.search || "";
    const position =dropDown.position.id||"";
    const grade=dropDown.grade.id||"";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (orgUnitId) params.append("orgUnit", orgUnitId);
    if (position) params.append("position", position);
    // if (classification) params.append("classification", classification);
    if (grade) params.append("grade", grade);
    if (start) params.append("start", start);
    if (length) params.append("limit", length);
    if (search) params.append("search", search);
     const queryString = params.toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_LIST_EXCEL}?params=travelled&${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) =>{ showToast.error(msg || "");setLoadingExcel(false)},
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };
  return (
    <div className="p-2">
      <PageHeader title="Employee"  buttons={[
           {
             label: "+Add Employee",
             onClick: handleAddEmployee,
             color:'#2e8dd3'
           },
            {
                   label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                    onClick:downloadExcelGet,
                  color: loadingExcel ? COLORS.disable : COLORS.primary,
                              disable: loadingExcel ? true : false,
                   },
           ]} />
      <BasicDataTable
        paginationTotalRows={data?.data?.Pagination?.TotalEmployees || 0}
        showSpinner={isLoading}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        dynamicHeightOnRowsPerPage={true}
        Title="Employee List"
        SearchPlaceholder="Search By Emp Code and Name"
        columns={EmployeeListColumns(handleEmployeeView)}
        data={data?.data?.Employees || []}
        headerContent={
           <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={orgUnitsList?.data || []}
        onSelect={(e) => {
          handleOrgUnit(e)
        }}
        defaultLabel={dropDown?.orgUnit.label}
        width="auto"
        isShowHeading
        DropdownHeading="Org Unit"
        headingColor="#2e8dd3"
      />

      <RoundedDropdown
        options={gradeMaster?.data || []}
        onSelect={(e) => {
          handleGrade(e);
        }}
        defaultLabel={dropDown?.grade?.label}
        width="auto"
        isShowHeading
        DropdownHeading="Grade"
        headingColor="#2e8dd3"
      />

      <CustomDropdown
        placeholder="All"
        DropdownLabel="Position"
        value={dropDown?.position.label}
        onChange={(id) => {
          setPosition((prev: any) => ({
            ...prev,
            Position: id,
            page: 1,
            orgUnirId:dropDown?.orgUnit.id||""
          }));


        }}
        key={dropDown.orgUnit.id}
        fetchData={async ({ page, limit, search }) => {
          const res = await getAllPositionList({
            page,
            limit,
            search,
            orgUnitId: dropDown?.orgUnit.id || ""
          });

          const rawData = res?.data?.Positions || {};
          console.log(rawData);
          let formatted = rawData?.map((item: any) => ({
            id: item.PositionId,
            label: item.PositionName,
          }));

          // ✅ Add "All" only on the first page
          if (page === 1) {
            formatted = [{ id: "", label: "All" }, ...formatted];
          }
          const hasMore = Object.keys(rawData).length === limit;

          return {
            data: formatted,
            hasMore,
          };
        }}
        includeAllOption
      />
      {/* <RoundedDropdown
        options={props?.PositionDropdownList|| []}
        onSelect={(e) => {
          handleFilter("Position", e);
        }}
        onSearch={(val) => props.onPositionSearch(val)}
        defaultLabel="All"
        width="auto"
    onLoadMore={props.onPositionLoadMore}

        isShowHeading
        DropdownHeading="Position"
        headingColor="#2e8dd3"
      /> */}

      <RoundedDropdown
        options={employeeStatus?.data || []}
        onSelect={(e) => {
         handleEmployeeStatus(e)
        }}
        defaultLabel={dropDown?.employeeStatus?.label}
        width="auto"
        isShowHeading
        DropdownHeading="Status"
        headingColor="#2e8dd3"
      />
    </div>
        }
      />

      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={"Add Profile"}

        size="xl"
        content={
          <EditProfileModal
            toggle={toggleModal}
            refresh={refresh}
            setRefresh={setRefresh}
            mode="add"
          />
        }
      />
    </div>
  );
};

export default Employee;
